import { ErrorLevel } from './error-reporting/get-loggable-error';

const CATEGORY = 'external-calendar';

// A crash further down the calendar then names how many provider records were in play.
export const buildExternalCalendarFeedBreadcrumb = (
  kept: number,
  received: number,
) => ({
  category: CATEGORY,
  message: `feed: kept ${kept} of ${received} events`,
  level: ErrorLevel.Info,
});
